var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex c-gap-1 align-items-center"},[_c('img',{attrs:{"src":_vm.url ?? '/img/default.png',"alt":_vm.alt}}),_c('span',{staticClass:"w-100"},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }